import React, {Component} from 'react'
import {Lethargy} from 'lethargy'
import throttle from 'lodash.throttle'

export default class Swipe extends Component {

	componentDidMount() {
		this.lethargy = new Lethargy()
		this.testScrollValidity = this.lethargy.check.bind(this.lethargy)
		const throttleWait = 500
		const throttleOptions = {
			trailing: false
		}

		this.callback = throttle((scrollDirection) => {
			const {onSwipe, onSwipeUp, onSwipeDown} = this.props
			onSwipe && onSwipe(scrollDirection)
			if (scrollDirection > 0) {
				onSwipeDown && onSwipeDown()
			}
			else {
				onSwipeUp && onSwipeUp()
			}
		}, throttleWait, throttleOptions)

		this.handleTouchStart = this.handleTouchStart.bind(this)
		this.handleTouch = this.handleTouch.bind(this)
		this.handleTouchEnd = this.handleTouchEnd.bind(this)
		this.handleKey = this.handleKey.bind(this)
		this.handleWheel = this.handleWheel.bind(this)

		window.addEventListener('wheel', this.handleWheel)
		window.addEventListener('touchstart', this.handleTouchStart)
		window.addEventListener('touchmove', this.handleTouch)
		window.addEventListener('touchend', this.handleTouchEnd)
		window.addEventListener('keyup', this.handleKey)
	}

	componentWillUnmount() {
		window.removeEventListener('wheel', this.handleWheel)
		window.removeEventListener('touchstart', this.handleTouchStart)
		window.removeEventListener('touchmove', this.handleTouch)
		window.removeEventListener('touchend', this.handleTouchEnd)
		window.removeEventListener('keyup', this.handleKey)
	}

	handleTouchStart(e) {
		this.touchStartY = e.touches[0].clientY
		this.direction = 0
		//this.callback(deltaY)
	}

	handleKey(e) {
		if (e.keyCode === 38) {
			this.callback(-1)
		}
		else if (e.keyCode === 40) {
			this.callback(1)
		}
	}

	handleTouch(e) {
		e.preventDefault();
		const touchY = e.touches[0].clientY
		const direction = touchY - this.touchStartY
		this.direction = -direction
	}

	handleTouchEnd(e) {
		if (Math.abs(this.direction) < 20) return
		this.callback(this.direction)
	}

	handleWheel(e) {
		const {isDisabled} = this.props
		if (isDisabled) return
		const check = this.testScrollValidity(e)
		if (check) {
			return this.callback(-check)
		}
	}


	render() {
		const {children, onSwipe, onSwipeUp, onSwipeDown, isDisabled, ...others} = this.props
		return (
			<div {...others}>
				{children}
			</div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Swipe.js
 **/